//const Backofficebff: string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const SmsTemplateCommand: any = {
    GetSmsTemplateByTemplate: Backofficebff + '/v1/smstemplate/get-sms-template-by-template',
    UpsertSms: Backofficebff + '/v1/smstemplate/upsertsms',
    TriggerSms: Backofficebff + '/v1/smstemplate/triggersms',
};
